export default function getUrlVars(): any {
  const vars = {};
  const loaction = window.location.href.replace(/&amp;/g, "&");
  loaction.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    vars[key] = value;
    return m;
  });
  return vars;
}
